import React, { useState, useEffect } from 'react';
import { Eye } from 'lucide-react';

const VisitCounter = () => {
    const [visitCount, setVisitCount] = useState(null);
    const [status, setStatus] = useState('loading'); // loading | ready | error

    useEffect(() => {
        const incrementVisit = async () => {
            try {
                const response = await fetch('/api/visit', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                });

                if (response.ok) {
                    const data = await response.json();
                    setVisitCount(data.count);
                    setStatus('ready');
                    return;
                }

                console.error('Failed to increment visit count');
                // Fallback: try to get current count
                const getResponse = await fetch('/api/visits');
                if (getResponse.ok) {
                    const data = await getResponse.json();
                    setVisitCount(data.count);
                    setStatus('ready');
                    return;
                }
                setStatus('error');
            } catch (error) {
                console.error('Error with visit counter:', error);
                setStatus('error');
            }
        };

        incrementVisit();
    }, []);

    if (status === 'loading') {
        return null; // Don't show anything while loading
    }

    const label = status === 'ready' ? `${visitCount.toLocaleString()} visits` : 'Visit count unavailable';

    return (
        <div className="visit-counter" role="status" aria-label={label} title={label}>
            <Eye size={13} strokeWidth={1.75} aria-hidden="true" />
            <span className="visit-counter-value">{status === 'ready' ? visitCount.toLocaleString() : '—'}</span>
        </div>
    );
};

export default VisitCounter;
